import React, {useState} from 'react'
import { Notification, definedNotifications } from './model'
import * as R from 'ramda'
import { Workflow, WNode } from '../ow/model'

import { Button } from 'react-bootstrap'
import {useOrderChannel, pushToOrderChannel} from 'views/order/v5/api/order-state'
import { Line, Line2 } from '../fragments/comp/panel'

import cx from 'classnames'
import { Order } from '../model-order'

export interface NotificationInfoProps {
  notification: Notification
  workflow: Workflow
  onSetCurrentNode: (w: WNode) => void
  order: Order
  highlight?: boolean
}
export default function NotificationInfo({ notification, highlight, workflow, onSetCurrentNode}: NotificationInfoProps) {
  const [ expand, setExpand ] = useState(false)
  const [ busy, setBusy ] = useState(false)

  const orderChannel = useOrderChannel()

  const onSendNotification = (n: Notification) => {
    if (orderChannel && confirm("Are you sure you want to send this notification again?")) {
      setBusy(true)
      pushToOrderChannel(orderChannel, 'trigger_notification', {id: n.id})
        .receive('ok', (_response?: any) => setBusy(false)) 
        .receive('error', (_message?: any) => setBusy(false))
        .receive('timeout', () => setBusy(false))
    }
  }


  const nodes = notification.workflow_nodes
    .map((id: string) => {
      const node = workflow.nodes.find(R.propEq('id', id))
      if (node) {
        return <span key={id} className="acts-as-link" onClick={() => onSetCurrentNode(node)}>{node.name}</span>
      } else {
        return <span key={id}>{id}?!?</span>
      }
  })

  const renderDetails = () => {
    return (
      <>
        <div>running on {R.intersperse(<>, </>, nodes)}</div>
        { (notification as any).outcomes ? <Outcomes outcomes={(notification as any).outcomes} /> : null }
        <div>
          <Button onClick={(_e) => onSendNotification(notification)} disabled={busy}>
            { busy ? "Sending...." : "Notify Again" }
          </Button>
        </div>
      </>
    )
  } 
  
  return (
    <Line2 highlight={highlight}>
      <span className={cx("fa", {"fa-plus": !expand, "fa-minus": expand})} onClick={() => setExpand(!expand)}></span>{' '}
      {notification.name} <span className="badge badge-success">{definedNotifications[notification.type]}</span>
      { (expand || highlight) && renderDetails() }
    </Line2>
  )
}

function Outcomes(props: { outcomes: any }) {
  const data = R.toPairs(props.outcomes)
    .filter(([key, value]) => key != '__typename' && !!value)
  if (data.length) {
    return (
      <ul>
        {data.map(([key, value]) => <li key={key}>{`on ${key}`}: {value}</li>)}
      </ul>
    )
  } else { return null }
}
